import { FeatureSwitch } from '@if/core/types'

class FeatureFlags {
  // Example feature flag
  public readonly activateDownloadFCFButton: boolean
  public readonly useLoanDateOverrideInteracTransfers: boolean

  constructor(featureSwitchDtos: FeatureSwitch[]) {
    const activatedFeatureSwitches = new Set(featureSwitchDtos.filter((x) => x.isActivated).map((x) => x.id))
    this.activateDownloadFCFButton = activatedFeatureSwitches.has('ActivateDownloadFCFButton')
    this.useLoanDateOverrideInteracTransfers = activatedFeatureSwitches.has('UseLoanDateOverrideInteracTransfers')
  }
}

export default FeatureFlags
